import { styled } from 'styled-components'
import { withStyles } from '@mui/styles'
import { Drawer as MuiDrawer, Dialog as MuiDialog } from '@mui/material'
import { onSmallScreen } from 'mixtiles-web-common'
import { ReactComponent as CloseIcon } from '../../../components/TopBar/CloseButton/close-icon.svg'

// Using withStyles instead of styled-components with classnames (such as .MuiDrawer-paper),
// because MUI adds random id to the classnames (for example .MuiDrawer-paper-830) and it doesn't work
export const Drawer = withStyles({
  root: {
    '&>div.MuiBackdrop-root': {
      opacity: '0.5 !important',
    },
  },
  paper: {
    borderRadius: '16px 16px 0 0',
  },
})(MuiDrawer)

export const Dialog = withStyles({
  paper: {
    width: 475,
    borderRadius: 20,
  },
})(MuiDialog)

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
  position: relative;

  ${onSmallScreen()} {
    padding: 65px 0 58px;
  }
`

export const CloseButton = styled(CloseIcon)`
  position: absolute;
  top: 40px;
  right: 42px;

  path,
  rect {
    fill: ${({ theme }) => theme.colors.darkBlack2};
  }
`

export const Title = styled.div`
  margin: 30px 0 6px;
  font-weight: 700;
  font-size: 24px;
`

const Text = styled.div`
  font-size: 18px;
  line-height: 24px;
  text-align: center;
`

export const Description = styled(Text)`
  max-width: 344px;
`

export const Separator = styled.div`
  width: 24px;
  height: 2px;
  background: #b5a7ac;
  opacity: 0.5;
  border-radius: 30px;
  margin: 16px 0;
`

export const BottomText = styled(Text)``

export const Cta = styled.div`
  width: 141px;
  margin-top: 28px;
`
